import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { assignGatewayHop, clearGatewayHopOverlay, isReactGatewayPath } from './gateway-hop';

/// <summary>
/// Full-loads React gateway prefixes so nginx serves the React SPA.
/// Angular routerLink never reaches the gateway on its own.
/// </summary>
@Injectable({
    providedIn: 'root'
})
export class GatewayHopService {
    constructor(private router: Router) {
        this.router.events.pipe(
            filter((event): event is NavigationStart => event instanceof NavigationStart)
        ).subscribe((event) => {
            if (isReactGatewayPath(event.url)) {
                assignGatewayHop(event.url);
            }
        });
    }

    /// <summary>
    /// Hides the hop overlay once Angular has booted on an Angular-owned URL.
    /// </summary>
    clearOverlay(): void {
        clearGatewayHopOverlay();
    }
}
